<template lang="pug">
.note
  .d-flex.flex-sm-row.align-items-center.justify-content-sm-between
    .author.d-flex.align-items-center
      HubAvatar.mr-10(
        :key="note.author.id"
        :user-id="note.author.id"
        avatar-style="speck"
      )
      p.text.m-0
        strong {{ note.author.text }}
    p.recordedAt.hint.small.text-muted.m-0 {{ $filters.formatDateTime(note.recorded_at, false) }}

  p.text.my-5 {{ note.text }}
  .note__attachments
    template(v-for="attachment in note.attachments" :key="attachment.original.url")
      a.note__attachments__item.gallery-item(
        :href="attachment.original.url"
        :data-sub-html="attachmentsCaption"
      )
        img.note__attachments__item__thumb(:src="attachment.thumb.url")
</template>

<script>
export default {
  name: 'WorkOrdersJobNote',
  props: {
    note: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    /**
     * In order to prevent injections, we need to process the text via the `escapeHTML`; This shouldn't be necessary
     * as the note is just plaintext, but it's being used as HTML in LightGallery for the image captions.
     * We either return the note.text (if any and escaped) or we return a `&nbsp;`, otherwise notes without
     * text render the text of the prev.note that was opened in LightGallery.
     */
    attachmentsCaption() {
      return HubstaffUtils.escapeHTML(this.note.text) || '&nbsp;';
    },
  },
};
</script>
